import { AlertTriangle } from 'lucide-react';
import { useState } from 'react';
import { Button } from './Button';
import { Modal } from './Modal';

/**
 * Destructive-action guard. Every delete/suspend/void in the app routes through
 * this so the wording and the double-check are consistent.
 */
export function ConfirmDialog({ open, onClose, onConfirm, title, message, confirmLabel = 'Confirm', tone = 'danger' }: {
  open: boolean; onClose: () => void; onConfirm: () => void | Promise<void>;
  title: string; message: string; confirmLabel?: string; tone?: 'danger' | 'primary';
}) {
  const [busy, setBusy] = useState(false);
  return (
    <Modal
      open={open} onClose={onClose} title={title} size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button
            variant={tone === 'danger' ? 'danger' : 'primary'}
            loading={busy}
            onClick={async () => { setBusy(true); try { await onConfirm(); onClose(); } finally { setBusy(false); } }}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="flex gap-3">
        {tone === 'danger' && (
          <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600 dark:bg-red-900/40 dark:text-red-400">
            <AlertTriangle className="h-5 w-5" />
          </span>
        )}
        <p className="text-sm text-ink-muted">{message}</p>
      </div>
    </Modal>
  );
}
